if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				if (this.form && this.form.querySelector("[name=id]")) {
					this.form.querySelector("[name=id]").disabled = false;
				}
				if (this.form) {
					this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				}
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer") && this.submitButton)
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			getSelectedVariantId() {
				// Search within closest container (quick-add modal, product section, etc.)
				const container =
					this.closest(
						'.product__info-container, .product__info-wrapper, .quick-add-modal, section, [id^="ProductInfo-"]'
					) || document;

				const variantPicker =
					container.querySelector("variant-selects, variant-radios") ||
					document.querySelector("variant-selects, variant-radios");

				if (!variantPicker) return null;

				if (variantPicker.currentVariant && variantPicker.currentVariant.id) {
					return variantPicker.currentVariant.id;
				}

				const jsonScript = variantPicker.querySelector(
					'script[type="application/json"]'
				);
				if (jsonScript) {
					try {
						const variants = JSON.parse(jsonScript.textContent);
						const selects = Array.from(
							variantPicker.querySelectorAll("select"),
							(s) => s.value
						);
						const radios = Array.from(
							variantPicker.querySelectorAll("input[type='radio']:checked"),
							(r) => r.value
						);
						const selectedOpts = selects.length ? selects : radios;
						const matched = variants.find((v) =>
							v.options.every((opt, idx) => selectedOpts[idx] === opt)
						);
						if (matched) return matched.id;
					} catch (e) {
						console.error("Error resolving variant ID:", e);
					}
				}
				return null;
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (!this.submitButton) return;
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				// Ensure the correct variant ID is set on the form before submission
				const selectedVariantId = this.getSelectedVariantId();
				if (selectedVariantId && this.form) {
					const idInput = this.form.querySelector('input[name="id"]');
					if (idInput) {
						idInput.value = selectedVariantId;
					}
				}

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (selectedVariantId) {
					formData.set("id", selectedVariantId);
				}

				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
